import { gql } from '@apollo/client';

export const previewUpgradeToSeriesThreePlusModuleQuery = gql`
  query ECOMMERCE_previewUpgradeToSeriesThreePlusModule($input: UpgradeToSeriesThreePlusModuleInput!) {
    previewUpgradeToSeriesThreePlusModule(input: $input) {
      subtotalInCents
      shippingInCents
      taxInCents
      totalInCents
    }
  }
`;

export const purchaseUpgradeToSeriesThreePlusModuleMutation = gql`
  mutation ECOMMERCE_purchaseUpgradeToSeriesThreePlusModule($input: UpgradeToSeriesThreePlusModuleInput!) {
    purchaseUpgradeToSeriesThreePlusModule(input: $input) {
      chargeInvoice {
        number
      }
      giftCardInvoices {
        number
      }
      isGWP
      isReturningCustomer
    }
  }
`;
